// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__1IgXd","tooltip":"styles_tooltip__1Foev","flagCont":"styles_flagCont__2Rr6d"};